module.exports = __webpack_public_path__ + "static/media/signup-image-1.35e86133.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/signup-image-1.jpg
// module id = 1308
// module chunks = 0